import { render, staticRenderFns } from "./EditarAdmision.vue?vue&type=template&id=5ffcda1e"
import script from "./EditarAdmision.vue?vue&type=script&lang=js"
export * from "./EditarAdmision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports